"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var _default = exports.default = {
  "config": {
    "isInitialized": true
  },
  "traits": {
    "isDocker": false,
    "isCI": false,
    "machineId": null,
    "projectId": "ae15d0a10cf25cfd753c466b94dd5cf814d78434c6184cc6864d60251bfeb637",
    "sessionId": "b3731096fa9dabc800935026979fe269d196613f624bab9fe266fd734a47ae71",
    "anonymousId": "9139af6f2073c75d2c6e155eabd23b1b4066817e479e1100a6a908c421268e5b"
  }
};